export interface Trait {
  iconSrc: string
  name: string
  description: string
}

export const traits = {
  insectFriendly: {
    iconSrc: '/img/icons/tree-traits/insect-friendly.svg',
    name: 'Insect friendly',
    description:
      'These trees provide food or shelter to one or many types of insects.'
  } as Trait,
  medicinal: {
    iconSrc: '/img/icons/tree-traits/medicinal.svg',
    name: 'Medicinal use',
    description: 'Used by Māori or early settles to treat ailments.'
  } as Trait,
  mythology: {
    iconSrc: '/img/icons/tree-traits/legend.svg',
    name: 'Mythology',
    description: 'Trees feature in stories and whakataukī.'
  } as Trait,
  symbolic: {
    iconSrc: '/img/icons/tree-traits/symbolic.svg',
    name: 'Symbolic',
    description:
      'Features strongly in Māori culture and is used as a national symbol of New Zealand.'
  } as Trait,
  edible: {
    iconSrc: '/img/icons/tree-traits/edible.svg',
    name: 'Edible',
    description:
      'Humans eat parts of the tree - or did in the past. Always check with an expert before you sample anything.'
  } as Trait,
  birdFriendly: {
    iconSrc: '/img/icons/tree-traits/bird-friendly.svg',
    name: 'Bird friendly',
    description:
      'Birds love the nectar or berries from these trees and often play a role in dispersing seeds in the process.'
  } as Trait,
  poison: {
    iconSrc: '/img/icons/tree-traits/poison.svg',
    name: 'Poison',
    description:
      'Parts of this tree can be poisonous if eaten by humans or animals.'
  } as Trait,
  earlyLiving: {
    iconSrc: '/img/icons/tree-traits/early-living.svg',
    name: 'Early living',
    description:
      'Māori or early settlers used this tree for timber, craft or other uses.'
  } as Trait
}
